var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerStyles.scss'; // Подключение созданных стилей
var MyDatePicker = function (_a) {
    var startDate = _a.startDate, setStartDate = _a.setStartDate;
    return (_jsx("div", __assign({ style: { position: 'relative' } }, { children: _jsx(DatePicker, { selected: startDate, onChange: function (date) { return setStartDate(date || new Date()); }, dateFormat: "dd.MM.yyyy", className: "date-picker-input", popperPlacement: "bottom-end", showPopperArrow: false }) })));
};
export default MyDatePicker;
